import {useMutation, MutationOptions} from '@tanstack/react-query';
import {AxiosError} from 'axios';
import {ColumnNames, ShipmentIds} from '@shipwell/backend-core-singlerequestparam-sdk';
import {getFilteredColumnNames} from './utils';
import {getShipmentsDownloadCsv} from 'App/api/referenceData/typed';

export type GetShipmentsDownloadCsvMutationOptions = Omit<
  MutationOptions<unknown, AxiosError<{error_message: string}>, unknown>,
  'mutationFn'
>;

const useGetShipmentsDownloadCsvMutation = ({
  shipmentIds,
  columnNames,
  options = {}
}: {
  shipmentIds: ShipmentIds;
  columnNames: ColumnNames;
  options?: GetShipmentsDownloadCsvMutationOptions;
}) => {
  const filteredColumnNames = getFilteredColumnNames(columnNames);
  return useMutation({
    mutationFn: () =>
      getShipmentsDownloadCsv({
        shipmentIds,
        columnNames: filteredColumnNames
      }),
    ...options
  });
};

export default useGetShipmentsDownloadCsvMutation;
